/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../ISymbolData';
import StreakTrackerRuleBase from './StreakTrackerRuleBase';

/** Rule to find symbols scattered across reels. */
@cc._decorator.ccclass
export default class ScatterSymbolCountRule extends StreakTrackerRuleBase
{
    /**
     * @hidden
     * No direct rule filtering, retruns all rules.
     */
    protected applyRuleFilter(): ISymbolData[] { return this.validSymbols;	}
}
